class Tabs {
    constructor() {
        this.tabs = document.querySelectorAll('[data-sw-tab]');
        this.tabs.forEach((tab) => {
            tab.addEventListener('click', this.title.bind(this));
        })
    }

    title (event) {
        const activeIndex = event.target.getAttribute('data-tab-index') * 1;
        this.tabs.forEach((tab) => {
            const tabIndex = tab.getAttribute('data-tab-index') * 1;
            tab.classList.remove('active');
            tab.closest('[data-sw-tabs]').querySelector('[data-tab-content-index="'+tabIndex+'"]').classList.remove('active');
        });

        event.target.classList.add('active');
        event.target.closest('[data-sw-tabs]').querySelector('[data-tab-content-index="'+activeIndex+'"]').classList.add('active');
    }
}

class AddToCartCustomize {

    constructor() {
        if (typeof Spurit?.global?.onReady !== 'function') {
            return
        }
            Spurit.global.onReady(
                ['cart', 'checkout', 'atc'],
                () => {

                    Spurit.global.atc.onBefore((event, target, lineItems, mode, next) => {
                        next(Spurit.global.constants.ATC.SUBMIT_MODE_AJAX, lineItems);
                    });
                    Spurit.global.atc.onAfter((event, target, lineItems, mode) => {
                        const cartAdapter = Spurit.global.cartPool.getAdapter('swm-subscribe-application');
                        let closed = false;
                        cartAdapter.onChange(async () => {
                            const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                            cartNotification.addEventListener('cartClosed', ()=>{
                                closed = true;
                            });
                            let button = await this.getHtml('cart-notification-button');
                            let icon = await this.getHtml('cart-icon-bubble');
                            let product = await this.getHtml('cart-notification-product');
                            let drawer = await this.getHtml('cart-drawer');
                            let variant = lineItems[0] ?? 0;
                            const cart = await cartAdapter.getItems();
                            if (!variant && cart.length) {
                               variant = cart[0];
                            }
                            if (!variant || !cart.length || closed) {
                                closed = false;
                                return;
                            }
                            let total = 0;
                            let lineItem = [];
                            for (let i = 0; i < cart.length; i++) {
                                if (variant.id === cart[i].id) {
                                    lineItem = cart[i];
                                }
                                total += cart[i].quantity;
                            }

                            lineItem.sections = [];
                            lineItem.sections['cart-notification-button'] = button;
                            lineItem.sections['cart-icon-bubble'] = icon;
                            lineItem.sections['cart-notification-product'] = product;
                            lineItem.sections['cart-drawer'] = drawer ?? '';

                            setTimeout(() => {

                                publish(PUB_SUB_EVENTS.cartUpdate, {
                                    source: 'product-form',
                                    productVariantId: lineItem.id,
                                    cartData: cart,
                                });
                                cartNotification.renderContents(lineItem);
                                closed = false;
                                cartNotification.classList.remove('is-empty');
                                cartNotification.classList.remove('sw-is-empty');
                            }, 100);
                        })
                    });
                }
            );
    }

    async getHtml(sectionID) {
        let url = `${window.location.pathname}?section_id=${sectionID}`;
        const response = await fetch(url);
        return await response.text();
    }
}

class VariantChange {
    constructor() {
        subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
            const variantShortDescription = document.querySelector('[data-sw-variant="'+data.variant.id+'"]');
            const variantShortDescriptionContainer = document.querySelector('.sw-variant-selector-description');

            if (variantShortDescription && variantShortDescriptionContainer) {
                variantShortDescriptionContainer.innerHTML = variantShortDescription.innerHTML;
            }

            const nm = document.querySelector('[data-sw-nm-form]');
            const atc = document.querySelector('[data-sw-atc-form]');
            const recurring = document.querySelector('[data-sw-recurring-form]');
            //const subscribe = document.querySelector('#spurit-subscription-customize-widget');
            if (!nm || !atc) {
                return
            }
            if (data.variant.available) {
                nm.classList.add('hide');
                atc.classList.remove('hide');
                if(recurring) {
                    recurring.classList.remove('hide')

                }
            } else {
                atc.classList.add('hide');
                nm.classList.remove('hide');
                if(recurring) {
                    recurring.classList.add('hide')

                }
            }
        })
    }
}

class Carousel {
    constructor() {
        const sliderEl = document.querySelector('.sw-main-product-slider');
        if (!sliderEl?.swiper) return;
        this.swiper = sliderEl.swiper;
        this.swiper.on('slideChange', this.pauseMedia.bind(this));
    }

    pauseMedia () {
        for (let i = 0; i < this.swiper.slides.length; i++) {
            let parent = this.swiper.slides[i];
            let video = parent.querySelector('video');
            if (video) {
                video.pause();
            }
        }
    }
}

class ProductGalleryThumbs {
    constructor() {
        this.mainEl = document.querySelector('.sw-main-product-slider');
        this.thumbsWrap = document.querySelector('.sw-main-product-thumbs-wrap');
        this.sliderWrap = document.querySelector('.sw-main-product-slider-wrap');
        this.featuredCover = document.querySelector('.sw-main-product-featured-cover');
        if (!this.mainEl?.swiper || !this.thumbsWrap) return;

        this.mainSwiper = this.mainEl.swiper;
        this.thumbsEl = this.thumbsWrap.querySelector('.sw-main-product-thumbs');
        if (!this.thumbsEl?.swiper) return;
        this.thumbsSwiper = this.thumbsEl.swiper;
        this.thumbs = this.thumbsWrap.querySelectorAll('.sw-main-product-thumb');

        this.syncFromMain = this.syncFromMain.bind(this);
        this.mainSwiper.on('slideChange', this.syncFromMain);

        const hasFeaturedCover = this.sliderWrap?.classList.contains('has-featured-cover');
        if (!hasFeaturedCover) this.syncFromMain();

        this.thumbs.forEach((thumb) => {
            thumb.addEventListener('click', () => this.onThumbClick(thumb));
        });
    }

    onThumbClick(thumb) {
        const index = parseInt(thumb.getAttribute('data-thumb-index'), 10);
        if (Number.isNaN(index)) return;
        if (this.sliderWrap?.classList.contains('has-featured-cover')) {
            this.sliderWrap.classList.remove('has-featured-cover');
            this.featuredCover?.classList.add('is-hidden');
        }
        this.mainSwiper.slideTo(index);
        this.syncFromMain();
        if (this.thumbsSwiper && this.thumbs.length > this.thumbsSwiper.params.slidesPerView) {
            this.thumbsSwiper.slideTo(index);
        }
    }

    syncFromMain() {
        const activeIndex = this.mainSwiper.realIndex ?? this.mainSwiper.activeIndex;
        this.thumbs.forEach((thumb) => {
            const index = parseInt(thumb.getAttribute('data-thumb-index'), 10);
            thumb.classList.toggle('is-active', index === activeIndex);
        });
        if (this.thumbsSwiper && this.thumbs.length > this.thumbsSwiper.params.slidesPerView) {
            this.thumbsSwiper.slideTo(activeIndex);
        }
    }
}
(() => {
    let checkInterval, timeOutID;
    checkInterval = setInterval(() => {
        if (typeof Spurit !== 'undefined' && typeof Spurit?.global?.onReady === 'function') {
            clearInterval(checkInterval);
            clearTimeout(timeOutID);
            new AddToCartCustomize();
        }
    }, 100);
    timeOutID = setTimeout(() => {
        clearInterval(checkInterval);
    }, 120000);
})();

window.addEventListener('DOMContentLoaded', () => {
    new Tabs();
    new Carousel();
    setTimeout(() => {
        new VariantChange();
        new ProductGalleryThumbs();
    }, 100);
});